'use client';

import { useRouter } from 'next/navigation';

import { Icons } from '../icons';

export default function BackButton() {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    router.back();
  };

  return (
    <button className="flex items-center px-4" aria-label="Вернуться назад" onClick={handleClick}>
      <Icons.LeftButtonArrow
        width={16}
        height={16}
        className="text-blue-main mr-1 -ml-2 dark:text-white"
      />
      <span className="text-blue-main font-medium dark:text-white">Назад</span>
    </button>
  );
}
